import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import {
  PanelAccordion,
  PANEL_ACCORDION_OPTION_VARIANT_SECONDARY
} from 'mailup-web-components'
import EmbeddedImages from './components/EmbeddedImages/EmbeddedImages'
import DynamicFields from './components/DynamicFields/DynamicFields'
import AdvancedPersonalization from './components/AdvancedPersonalization/AdvancedPersonalization'
import AutomaticLinkTracking from './components/AutomaticLinkTracking/AutomaticLinkTracking'
import WebAnalyticsTrackingCode from './components/WebAnalyticsTrackingCode/WebAnalyticsTrackingCode'
import evalCondition from 'Helpers/evalCondition'

import { messageState } from '../recoil/state/message'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { MESSAGE_STR_TYPE_CONTENTSCAMPAIGN } from 'Constants/'
import { pageState } from '../recoil/state/page'

const BoxAdvancedSettings = () => {
  const intl = useIntl()
  const { messageType } = useRecoilValue(messageState)
  const { loaded, scrollToConsumed } = useRecoilValue(pageState)
  const setPageState = useSetRecoilState(pageState)

  const qsParams = new URLSearchParams(useLocation().search)
  const scrollTo = qsParams.get('scrollTo')

  const [expanded, setExpanded] = useState(scrollTo === 'link_tracking')
  const linkTrackingRef = useRef(null)

  const isDynamicFieldVisible = evalCondition('uo:DYNFLD')
  const isEmbeddedImagesVisible = evalCondition('uo:EMB')
  const isPersonalizationVisible =
    evalCondition('co:ADVPERSONALIZATION') &&
    messageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN

  const hanleOnCollapseChange = e => {
    setExpanded(!expanded)
  }

  useEffect(() => {
    if (
      !scrollToConsumed &&
      loaded &&
      scrollTo === 'link_tracking' &&
      linkTrackingRef &&
      linkTrackingRef.current
    ) {
      setExpanded(true)
      setTimeout(() => {
        linkTrackingRef.current.scrollIntoView({ behavior: 'smooth' })
        setPageState(prev => ({ ...prev, scrollToConsumed: true }))
      }, 1000)
    }
  }, [scrollTo, loaded, scrollToConsumed, linkTrackingRef.current])

/*   const openBox = () => {
    return scrollTo && scrollTo === 'link_tracking'
  } */

  return (
    <>
      <PanelAccordion
        title={intl.formatMessage({
          id: 'Load.SavedEmailWizard.LabelAdvancedSettings'
        })}
        collapsed={!expanded}
        data-mu-test='overview-message__box-advanced-settings'
        onChange={hanleOnCollapseChange}
        panelVariant={PANEL_ACCORDION_OPTION_VARIANT_SECONDARY}
      >
        {isDynamicFieldVisible && <DynamicFields />}
        {isEmbeddedImagesVisible && <EmbeddedImages />}
        <div ref={linkTrackingRef}>
          <AutomaticLinkTracking />
        </div>

        <WebAnalyticsTrackingCode />

        {isPersonalizationVisible && <AdvancedPersonalization />}
      </PanelAccordion>
    </>
  )
}

export default BoxAdvancedSettings
